import React from 'react';
import { motion } from 'framer-motion';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Introduction } from './components/Introduction';
import { ErrorSection } from './components/ErrorSection';
import { EditorialQuote } from './components/EditorialQuote';
import { FinalSection } from './components/FinalSection';
import { RelatedGuides } from './components/RelatedGuides';
import { Footer } from './components/Footer';
import { guideErrors } from './data/guide';
export function App() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.9,
    ease: [0.22, 1, 0.36, 1]
  }} className="min-h-full w-full bg-warmwhite font-sans antialiased" data-id="element-0" data-mp="2mnng03a42a0r">
      <Header data-id="element-1" data-mp="2whxaprmizken" />

      <main data-id="element-2" data-mp="28ufnm9e7hai0">
        <Hero data-id="element-3" data-mp="28tw6guwdqq51" />
        <Introduction data-id="element-4" data-mp="28tmej1rry8wp" />

        <section aria-label="Los siete errores" className="bg-warmwhite" data-id="element-5" data-mp="28sutgkvsztko">
          <div className="mx-auto max-w-6xl px-6 sm:px-10" data-id="element-6" data-mp="23w4c7u89irxo">
            
          </div>
          <div className="mt-16" data-id="element-7" data-mp="3ikh5q2ysagvt">
            {guideErrors.map((item, i) => <ErrorSection key={item.number} item={item} reversed={i % 2 === 1} data-id="element-8" data-mp="3ii4r9zs8ioni" data-mpi={i} />)}
          </div>
        </section>

        <EditorialQuote data-id="element-9" data-mp="3rcj6y3gog175" />
        <FinalSection data-id="element-10" data-mp="3rbzpsoyupgu6" />
        <RelatedGuides data-id="element-11" data-mp="3rcsw5otwe4bs" />
      </main>

      <Footer data-id="element-12" data-mp="5yj0slx59ec" />
    </motion.div>;
}